import { FunderType } from "features/../../../shared/constants/enums";
import { shouldUseDefault } from "../../helpers";

export function correctCapitalCalcValues(
  newSheetData,
  fundingSection,
  funderTypeSettings,
) {
  const funderSettings = funderTypeSettings.find(
    (obj) =>
      obj.funderType == fundingSection.funderType &&
      obj.calcTableType == fundingSection.calcTableType,
  );

  if (
    fundingSection.funderType == FunderType.CoFunded &&
    shouldUseDefault(fundingSection.coFundedDealerPercentage)
  ) {
    fundingSection.coFundedDealerPercentage.value =
      funderSettings.supplierCoFund;
  }
  if (
    fundingSection.funderType == FunderType.Dealer &&
    shouldUseDefault(fundingSection.ipSyndicatePercentageYield)
  ) {
    const defaultYieldPercentages =
      newSheetData.defaults.defaultYieldPercentages.find(
        (x) =>
          x.quarter == newSheetData.capital.dealer.financeSelection.value &&
          x.paymentMethod == newSheetData.rates.paymentMethod &&
          x.financeType == newSheetData.rates.dealerFmv.financeType,
      );
    fundingSection.ipSyndicatePercentageYield.value = defaultYieldPercentages
      ? defaultYieldPercentages.yieldPercentage
      : 0;
  }
}
